import { ERROR_MESSAGES } from './constants'

const isNonBooleanNegative = (value: any): boolean => {
  return value !== false && !value
}
const isEmptyArray = (value: any): boolean => {
  return Array.isArray(value) && value.length === 0
}
const getIsMissingValue = (value: any): boolean => {
  return isNonBooleanNegative(value) || isEmptyArray(value)
}

type IDate = Date | null
type IDateArr = [IDate, IDate]

const getIsTooEarly = ([min, time]: IDateArr): boolean => {
  return !!min && !!time && time <= min
}
const getIsTooLate = ([max, time]: IDateArr): boolean => {
  return !!max && !!time && time >= max
}
const getIsValidDate = (date: IDate): boolean => {
  return !date || date.toString() === 'Invalid Date'
}

export const PROTOCOL = {
  unsecured: 'http://',
  secure: 'https://',
}

const linkRegex = /^https?:\/\/[w\.]{0,4}[^\.]+\.[a-zA-Z]{1,}\/?.+$/m // eslint-disable-line

const getIsValidURL = (value: string): boolean => {
  const isBlank = value === ''
  const isLink = linkRegex.test(value)
  return !isBlank && !isLink
}

const getIsMaxGreater = ([min, max]: number[]): boolean => {
  return max < min
}

/**
 * Each of these fns returns true if the given value is invalid
 */
export const RULES = {
  [ERROR_MESSAGES.REQUIRED]: getIsMissingValue,
  [ERROR_MESSAGES.TOO_EARLY]: getIsTooEarly,
  [ERROR_MESSAGES.TOO_LATE]: getIsTooLate,
  [ERROR_MESSAGES.VALID_DATE]: getIsValidDate,
  [ERROR_MESSAGES.VALID_TIME]: getIsValidDate,
  [ERROR_MESSAGES.VALID_URL]: getIsValidURL,
  [ERROR_MESSAGES.MAX_GREATER]: getIsMaxGreater,
}
